import PayMonthlyIncentiveBonus from '@/api/hr/pay-monthly-incentive-bonus'
import Employee from '@/api/hr/employee'
import IncentiveBonus from '@/api/hr/pay-item-incentive-bonus'
import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  cycle_year: moment().format('YYYY'),
  cycle_month: moment().format('MM'),
  employees: [],
  incentiveBonuses: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,

  RECEIVE_EMPLOYEES(state, employees) {
    state.employees = employees
  },

  RECEIVE_INCENTIVEBONUSES(state, incentiveBonuses) {
    state.incentiveBonuses = incentiveBonuses
  },
  SET_CYCLE_YEAR(state, data) {
    state.cycle_year = data
  },
  SET_CYCLE_MONTH(state, data) {
    state.cycle_month = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        cycle_month: context.state.cycle_month,
        cycle_year: context.state.cycle_year,
        ...context.state.queryBuilder
      },
      attributes
    )

    context.commit('SET_QUERY_BUILDER', attributes)

    return PayMonthlyIncentiveBonus.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create(context, data) {
    return PayMonthlyIncentiveBonus.store(data)
  },

  update(context, { id, ...data }) {
    return PayMonthlyIncentiveBonus.update(id, data)
  },

  destroy(context, id) {
    return PayMonthlyIncentiveBonus.destroy(id).then(response => {
      let resource = context.state.resources.find(r => r.record_id == id)

      if (resource) {
        context.state.resources.splice(context.state.resources.indexOf(resource), 1)
      }

      return response
    })
  },

  fetchEmployees(context, attributes = {}) {
    let params = {
      page: -1,
      fields: {
        hris_employee_profiles: 'employee_id,employee_name_en'
      },
      ...attributes
    }

    return Employee.get({ params }).then(response => {
      context.commit('RECEIVE_EMPLOYEES', response.data)
      return Promise.resolve(response)
    })
  },

  fetchIncentiveBonuses(context, attributes = {}) {
    let params = {
      page: -1,
      fields: {
        pay_item_compensate: 'inc_bonus_id,inc_bonus_item'
      },
      ...attributes
    }

    return IncentiveBonus.get({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params
    }).then(response => {
      context.commit('RECEIVE_INCENTIVEBONUSES', response.data)
      return Promise.resolve(response)
    })
  }
}
